import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../../store/userSlice";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../../nodeInstance";
import { useNavigate } from "react-router-dom";
import { setWorkflowIndex } from "../../../../../store/userSlice";

export default function OPS1_RejectPopUp({ setnewpopup, emp_id }) {
  const [rejectReason, setrejectReason] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const navigate=useNavigate();
  const submitHandeler = async (e) => {
    e.preventDefault();
    const url = `/insurance-dependent/rejectOps/111`;
    const body = {
      "comments_for_rejection":rejectReason,
    };
    setLoading(true);
    try {
      const response = await nodeinstance.put(url, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Rejected",
            color: "success",
          })
        );
      }
       setnewpopup(false);
       dispatch(setWorkflowIndex(0));
    navigate("/dashboard/dependent-addition")
    } catch (error) {
      setLoading(false);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center 
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 absolute left-[40%] top-[45%]">
          <form className="flex flex-col gap-3" onSubmit={submitHandeler}>
            <IoMdClose
              fontSize={15}
              onClick={() => setnewpopup(false)}
              className="cursor-pointer"
            />
            <p className="font-semibold">ADD COMMENT</p>
            <input
              type="text"
              className="w-[95%] border-2 p-2"
              name="rejectReason"
              value={rejectReason}
              onChange={(e) => setrejectReason(e.target.value)}
            />
            <button className="bg-black text-white w-[95%] py-1" type="submit">
              SUBMIT
            </button>
          </form>
        </div>
      </div>
    </>
  );
}
